import { useQuery } from "@tanstack/react-query";
import { hrEmployerApi } from "@/lib/api/hr";
import { EmptyState, Page, QueryGate, StatusBadge } from "@/components/shell/page";

export default function EmployerHoursPage() {
  const { data, isLoading, error } = useQuery({
    queryKey: ["hr", "employer", "hours"],
    queryFn: () => hrEmployerApi.hours(),
  });
  const rows = Array.isArray(data) ? data : [];

  return (
    <QueryGate loading={isLoading} error={error || !data ? "Could not load hours." : null}>
      <Page title="Hours" description="Timesheets built from each day’s log.">
        {rows.length === 0 && (
          <EmptyState title="No timesheets yet" body="They appear after employees log hours." />
        )}
        {rows.length > 0 && (
          <div className="overflow-hidden rounded-xl border bg-card shadow-sm">
            <table className="w-full text-left text-sm">
              <thead className="border-b bg-muted/60 text-xs uppercase tracking-wide text-muted-foreground">
                <tr>
                  <th className="px-4 py-3 font-medium">Employee</th>
                  <th className="px-4 py-3 font-medium">Period</th>
                  <th className="px-4 py-3 font-medium">Hours</th>
                  <th className="px-4 py-3 font-medium">Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row: any) => (
                  <tr key={row.id} className="border-b last:border-0">
                    <td className="px-4 py-3">{row.employee_id}</td>
                    <td className="px-4 py-3">
                      {row.period_start} – {row.period_end}
                    </td>
                    <td className="px-4 py-3 tabular-nums">{row.total_hours}h</td>
                    <td className="px-4 py-3">
                      <StatusBadge status={row.status} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Page>
    </QueryGate>
  );
}
